import { useInfiniteQuery } from 'react-query';
import { getSpeakers, listSpeakersPageSize } from 'src/common/services/speakers';
import { QueryKey } from 'src/config/queryKey';
import { Speaker } from 'src/common/models/speaker';
import { PageResultDTO } from 'src/common/models/page';

export const useSpeakersQuery = (initialData?: () => PageResultDTO<Speaker>) => {
  return useInfiniteQuery(QueryKey.SpeakerList, getSpeakers, {
    getNextPageParam: (lastPage, allPages) => {
      return lastPage && lastPage.totalResult > allPages.length * listSpeakersPageSize
        ? allPages.length + 1
        : false;
    },
    refetchOnMount: !initialData,
    initialData:
      initialData &&
      (() => ({
        pages: [initialData()],
        pageParams: [
          {
            pageParam: 1,
          },
        ],
      })),
  });
};
